import { defineStore } from 'pinia';

interface IUpdateSystemState {
  updateSystem0: boolean;
}

export const useUpdateSystemStore = defineStore('updateSystem', {
  state: (): IUpdateSystemState => ({
    updateSystem0: false,
  }),

  getters: {
    updateSystem: (state) => state.updateSystem0,
  },

  actions: {
    onUpdate() {
      this.updateSystem0 = true;
    },
    offUpdate() {
      this.updateSystem0 = false;
    },
  },
});

export default useUpdateSystemStore;
